import { render, staticRenderFns } from "./Grid.vue?vue&type=template&id=2de7b714&"
import script from "./Grid.vue?vue&type=script&lang=js&"
export * from "./Grid.vue?vue&type=script&lang=js&"
import style0 from "./Grid.vue?vue&type=style&index=0&id=2de7b714&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node/your.borobudurmarathon.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2de7b714')) {
      api.createRecord('2de7b714', component.options)
    } else {
      api.reload('2de7b714', component.options)
    }
    module.hot.accept("./Grid.vue?vue&type=template&id=2de7b714&", function () {
      api.rerender('2de7b714', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Grid.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Grid.vue
// module id = 552
// module chunks = 1 2